import _ from 'lodash';

const createErrorMessageSelector = actions => state => {
  return (
    _(actions)
      .map(action => _.get(state, `error.${action}`))
      .compact()
      .first() || ''
  );
};

export default createErrorMessageSelector;
